import React from "react";
import { I18n } from "@aws-amplify/core";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import Grid from "@material-ui/core/Grid";

import CloseIcon from "../../Common/CloseIcon";
import CustomButton from "../../Common/CustomButton";

import images from "../../../assets/img/images";

const PhotosSaved = (props) => {
  const { profileId, close, classes, photosNb, addAnotherProfile } = props;

  return (
    <Grid
      container
      direction="column"
      alignItems="stretch"
      style={{ height: "100%", width: "400px" }}
      wrap="nowrap"
    >
      <Grid item>
        <Grid container direction="row-reverse">
          <Grid item xs={2} className={classes.closeBtn}>
            <CloseIcon closeFunction={close} />
          </Grid>
          <Grid item xs={8} />
        </Grid>
      </Grid>
      <Grid item xs style={{ padding: "0px 48px 24px 48px" }}>
        <Grid container direction="column" alignItems="center">
          <Grid item className="text-54 text-center bold-500">
            {I18n.get("profiles_profileSaved")}
          </Grid>
          <Grid
            item
            className="text-54 text-center bold-500"
            style={{ marginTop: "10px" }}
          >
            {photosNb + " " + I18n.get("profiles_photosSaved")}
          </Grid>
          <Grid item style={{ margin: "12px 0px 38px 0px" }}>
            <img src={images.successIcon} alt="success" />
          </Grid>
          <Grid item className={classes.postCreationBtn}>
            <Link
              to={"/profiles/" + profileId}
              style={{ textDecoration: "none", fontSize: "inherit" }}
            >
              <CustomButton color="primary">
                {I18n.get("profiles_goToProfile")}
              </CustomButton>
            </Link>
          </Grid>
          <Grid item className={classes.postCreationBtn}>
            <CustomButton color="primary" onClick={addAnotherProfile}>
              {I18n.get("profiles_addAnotherProfile")}
            </CustomButton>
          </Grid>
          <Grid item className={classes.postCreationBtn}>
            <CustomButton color="primary" onClick={close}>
              {I18n.get("site_close")}
            </CustomButton>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

PhotosSaved.propTypes = {
  profileId: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  photosNb: PropTypes.number.isRequired,
  addAnotherProfile: PropTypes.func.isRequired,
};

export default PhotosSaved;
